import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { mapDashboardPath } from "@/lib/routes";

export function ProtectedRoute() {
  const { loading, profile, previewMode } = useAuth();
  const location = useLocation();

  if (loading && !profile && !previewMode) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-black text-white">
        <p className="text-sm text-zinc-400">Loading...</p>
      </div>
    );
  }

  if (!previewMode && !profile) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  if (!previewMode && profile?.status === "inactive") {
    return <Navigate to="/admin/login" replace />;
  }

  if (!previewMode && profile && location.pathname.includes("/dashboard")) {
    const normalizedPath = mapDashboardPath(location.pathname, profile.role);
    if (normalizedPath !== location.pathname) {
      return <Navigate to={normalizedPath} replace />;
    }
  }

  return <Outlet />;
}

export function GuestRoute() {
  const { loading, profile, previewMode } = useAuth();

  if (loading && !profile && !previewMode) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-black text-white">
        <p className="text-sm text-zinc-400">Loading...</p>
      </div>
    );
  }

  if (!previewMode && profile) {
    return <Navigate to={mapDashboardPath("/admin/dashboard", profile.role)} replace />;
  }

  return <Outlet />;
}
